import { useApi } from './api'

export const apiPatios = () => {
   const { api } = useApi()

   const obter= async (params) => {
      // Mocky: 
      //const { data } = await api.get('https://run.mocky.io/v3/08685610-ed39-4d80-b737-e501ab6cd3c8?mocky-delay=3000ms', { params })
      const { data } = await api.get('/patios', { params })
      return data
   }

   return {
      obter
   }
}
